import Http from "../http";

class CruzeTypeServices{
    static async getCruzeType(){
        return Http.get('/getCruzeType');
    }
    
    static async updateCruzeType(id,data){
        console.log("data in upodateCruzeType",data);
        return Http.update(`/editCruzeType/${id}`,data);
    }
    static async addCruzeType(data){
        // console.log("========================================data in the riderServices",data)
        return Http.post('/addCruzeType',data)
    }
    static async deleteCruzeType(id){
        return Http.delete(`/deleteCruzeType/${id}`);
    }
    
}
export default CruzeTypeServices